export default class Contact {
  constructor() {
    this.validationClass = 'js-show-validation';
    this.forms = document.querySelectorAll('.wpcf7 form');

    if (this.forms.length > 0) {
      this.init();
    }
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    this.forms.forEach((form) => {
      form.dataset.validationTriggered = 'false';
      form.dataset.isSubmitting = 'false';

      // 送信中の二重送信を抑止（キャプチャで CF7 より先に処理）
      form.addEventListener(
        'submit',
        (event) => {
          if (form.dataset.isSubmitting === 'true') {
            event.preventDefault();
            event.stopImmediatePropagation();
            return;
          }

          form.dataset.isSubmitting = 'true';
          this.setSubmitButtonsDisabled(form, true);
          form.dataset.validationTriggered = 'true';
          form.classList.add(this.validationClass);
        },
        true
      );

      form.addEventListener('wpcf7invalid', () => {
        this.finishSubmitting(form);
        this.dedupeValidationTips(form);

        if (form.dataset.validationTriggered !== 'true') {
          return;
        }
        form.classList.add(this.validationClass);
      });

      form.addEventListener('wpcf7mailsent', () => {
        this.finishSubmitting(form);
        form.dataset.validationTriggered = 'false';
        form.classList.remove(this.validationClass);
      });

      ['wpcf7mailfailed', 'wpcf7spam'].forEach((eventName) => {
        form.addEventListener(eventName, () => {
          this.finishSubmitting(form);
        });
      });

      form.addEventListener('wpcf7reset', () => {
        this.finishSubmitting(form);
        form.dataset.validationTriggered = 'false';
        form.classList.remove(this.validationClass);
      });
    });
  }

  finishSubmitting(form) {
    form.dataset.isSubmitting = 'false';
    this.setSubmitButtonsDisabled(form, false);
  }

  setSubmitButtonsDisabled(form, disabled) {
    form.querySelectorAll('input[type="submit"], button[type="submit"]').forEach((button) => {
      button.disabled = disabled;
    });
  }

  dedupeValidationTips(form) {
    form.querySelectorAll('.wpcf7-form-control-wrap, .o-form__input_block').forEach((container) => {
      const tips = container.querySelectorAll('.wpcf7-not-valid-tip');
      tips.forEach((tip, index) => {
        if (index > 0) {
          tip.remove();
        }
      });
    });
  }
}
